import { EXPERIENCE } from "@/data/content";
import { useReveal } from "@/hooks/useReveal";

export default function Experience() {
  const ref = useReveal();
  return (
    <section id="experience" ref={ref} data-testid="experience-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 reveal">
          <div>
            <span className="label">Experience</span>
            <h2 className="display mt-5 text-[2.25rem] sm:text-[3.25rem] max-w-2xl text-[var(--ink)]">
              Seventeen years of <span className="serif-italic">bringing ideas to life.</span>
            </h2>
          </div>
          <p className="text-sm text-[var(--ink-dim)] max-w-xs leading-relaxed">
            A studio founder and long-term design partner — the roles that shaped how I work across brand, web and communications.
          </p>
        </div>

        <div className="border-t border-[var(--line)]">
          {EXPERIENCE.map((e, i) => (
            <div
              key={e.company}
              data-testid={`experience-${i}`}
              className="reveal grid grid-cols-12 gap-4 items-start py-9 sm:py-11 px-2 sm:px-4 border-b border-[var(--line)]"
            >
              <div className="col-span-12 sm:col-span-3">
                <h3 className="display text-xl sm:text-2xl text-[var(--ink)]">{e.company}</h3>
                <div className="label mt-2">{e.period}</div>
              </div>
              <div className="col-span-12 sm:col-span-2">
                <p className="text-sm text-[var(--accent)] leading-snug">{e.role}</p>
              </div>
              <div className="col-span-12 sm:col-span-5">
                <p className="text-sm text-[var(--ink-dim)] leading-relaxed">{e.body}</p>
              </div>
              <div className="col-span-12 sm:col-span-2 flex flex-wrap gap-2 sm:justify-end">
                {e.tags.map((t) => (
                  <span key={t} className="chip rounded-full px-3 py-1 text-xs text-[var(--ink-dim)]">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
